module.exports = __webpack_public_path__ + "images/AuthPageBG-45e8b1ee.png";